import { render, staticRenderFns } from "./ModalNewDepartment.vue?vue&type=template&id=7ea6263b&"
import script from "./ModalNewDepartment.vue?vue&type=script&lang=js&"
export * from "./ModalNewDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports